// extracted by css-extract-rspack-plugin
export default {"emptyStateContainer":"ListEmptyState-module__emptyStateContainer__ypaZI"};